(function() {
  document.addEventListener('submit', function(e) {
    const form = e.target.closest('form[action="/cart/add"]');
    if (!form || form.classList.contains('installment')) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    const data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: data })
      .then(r => r.json())
      .then(() => fetch('/cart.js'))
      .then(r => r.json())
      .then(cart => {
        const cartIcon = document.querySelector('a[href="/cart"]');
        if (cartIcon) {
          let bubble = cartIcon.querySelector('.cart-count-bubble');
          if (!bubble) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            bubble.innerHTML = `<span aria-hidden="true">${cart.item_count}</span><span class="visually-hidden">${cart.item_count} ürün</span>`;
            cartIcon.appendChild(bubble);
          } else {
            bubble.style.display = '';
            bubble.querySelector('span[aria-hidden]').textContent = cart.item_count;
          }
        }
      });
  }, true);

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.quantity__button[name="minus"]');
    if (!btn) return;
    const input = btn.closest('.quantity').querySelector('.quantity__input');
    if (!input) return;
    if (parseInt(input.value) <= 1) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const row = btn.closest('tr[id^="CartItem"]');
      if (!row) return;
      const removeBtn = row.querySelector('cart-remove-button a');
      if (removeBtn) removeBtn.click();
    }
  }, true);
})();
